import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getProductHandoutType } from "src/api/product";
import useHandoutProductStore from "src/store/relatedProduct";
import { useLegacyPassLogic } from "./legacy/useLegacyPassLogic";
import PassMenuList from "./PassMenuList";
import PassSelectButton from "./PassSelectButton";
import PurchaseCTA from "./PurchaseCTA";
import { TabFormSection } from "./PurchaseLayouts";
import PurchaseNoFreepassTab from "./PurchaseNoFreepassTab";
import useEntitlementsQuery from "./useEntitlementsQuery";
import { usePassSelect } from "./usePassSelect";
/**
 * 유효한 이용권 보유 → 사용 유도 모듈 (Case 4)
 * - 이용권 선택 드롭다운
 * - 상품 수 정보
 * - 자료 보관함에 넣기 버튼
 */ const PurchaseValidMembershipTab = (param)=>{
    let { product , className , isInModal  } = param;
    const { handleUsePass  } = useLegacyPassLogic({
        product,
        skipConfirmation: true
    });
    const { selectedPurchaseOption  } = useHandoutProductStore((state)=>({
            selectedPurchaseOption: state.selectedPurchaseOption
        }));
    const handoutType = getProductHandoutType(product);
    const { data: passes = [] , isSuccess  } = useEntitlementsQuery({
        productId: product.id,
        isLoggedIn: true,
        freepassOnly: handoutType === "freepass",
        selectedPurchaseOption: selectedPurchaseOption,
        productHandoutType: handoutType
    });
    const { anchorEl , menuWidth , menuListOpen , selectedPass , handleSelectClick , handleSelectClose , handlePassSelect  } = usePassSelect(passes, isInModal);
    const isAllPassDisabled = isSuccess && passes.every((pass)=>pass.isDisabled);
    if (isAllPassDisabled) {
        return /*#__PURE__*/ _jsx(PurchaseNoFreepassTab, {
            product: product
        });
    }
    var _selectedPass_id;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(TabFormSection, {
                sx: {
                    mb: 2
                },
                title: "이용권 선택",
                children: [
                    /*#__PURE__*/ _jsx(PassSelectButton, {
                        open: menuListOpen,
                        onClick: handleSelectClick,
                        pass: selectedPass
                    }),
                    /*#__PURE__*/ _jsx(PassMenuList, {
                        anchorEl: anchorEl,
                        onClose: handleSelectClose,
                        open: menuListOpen,
                        menuWidth: menuWidth,
                        passes: passes,
                        onPassSelect: handlePassSelect,
                        selectedId: (_selectedPass_id = selectedPass === null || selectedPass === void 0 ? void 0 : selectedPass.id) !== null && _selectedPass_id !== void 0 ? _selectedPass_id : null
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(PurchaseCTA, {
                variant: "freepass",
                onClick: handleUsePass
            })
        ]
    });
};
export default PurchaseValidMembershipTab;
